var body = document.querySelector('body');
var btnOpenPopin = document.querySelector('.open-laureats-list');
var btnClosePopin = document.querySelector('#laureats-list .close');
var popin = document.querySelector('#laureats-list');
var popinOverlay = document.querySelector('#laureats-list .overlay');

btnOpenPopin.addEventListener('click', event => {
  openPopin();
});

btnClosePopin.addEventListener('click', event => {
  closePopin();
});
popinOverlay.addEventListener('click', event => {
  closePopin();
});


function openPopin() {
  popin.classList.add("active");
  setTimeout(function() {
    popin.classList.add("visible");
  }, 300);
  body.classList.add('overflow');
}

function closePopin() {
  popin.classList.remove("visible");
  setTimeout(function() {
    popin.classList.remove("active");
  }, 600);
  body.classList.remove('overflow');
}